import { AsyncButton, Button } from '@components/button';
import { Form, FormTextInput } from '@components/form';
import { Typography } from '@components/typography';
import { useInviteRemoteDevelopmentMutation } from '@generated/graphql';
import { Stack } from '@mui/material';
import { useState } from 'react';
import * as yup from 'yup';

const validationSchema = yup.object({
  email: yup.string().email('Invalid email').required('Email is required'),
});

export const ShareRemoteSessionModal = ({
  editorSessionId,
  onClose,
}: {
  editorSessionId: string;
  onClose: VoidFunction;
}) => {
  const [mode, setMode] = useState<'form' | 'message'>('form');
  const [inviteSession] = useInviteRemoteDevelopmentMutation();
  const handleFormSubmit = async (values: { email: string }) => {
    await inviteSession({ variables: { editorSessionId, email: values.email } });
    setMode('message');
  };
  if (mode === 'message') {
    return (
      <Stack gap={4}>
        <Typography align="center" variant="subtitle1">
          Invitation sent!
        </Typography>
        <Typography variant="body2" sx={{ maxWidth: '400px' }}>
          You will need to refresh your SSH keys by selecting the option in the Theia {'>'} SSH
          menu.
        </Typography>
        <Button fullWidth variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Stack>
    );
  }
  return (
    <Form
      initialValues={{
        email: '',
      }}
      validationSchema={validationSchema}
      onSubmit={handleFormSubmit}
      validateOnBlur={false}
      validateOnChange
    >
      {({ isValid, handleSubmit, dirty, isSubmitting }) => {
        return (
          <Stack>
            <FormTextInput name="email" label="Email" type="email" />
            <Stack gap={4}>
              <AsyncButton
                fullWidth
                loading={isSubmitting}
                disabled={!(isValid && dirty && !isSubmitting)}
                onClick={handleSubmit}
                data-cy="New-Workspace-Modal-Create-Button"
              >
                Invite
              </AsyncButton>
              <Button
                fullWidth
                variant="secondary"
                data-cy="New-Workspace-Modal-Cancel-Button"
                onClick={onClose}
              >
                Cancel
              </Button>
            </Stack>
          </Stack>
        );
      }}
    </Form>
  );
};
